export default function (instance) {
  return {
    getShopHeader() {
      return instance.get("api/v1/shopHeader/1/");
    },
    getShopFooter() {
      return instance.get("api/v1/shopFooter/1/");
    },
    getShopPageFromPath(slug) {
      return instance.get("api/v1/shopPageFromPath/1/?value=" + slug);
    },
    getCityInfo() {
      return instance.post(
        "https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address",
        {
          language: "ru",
        },
        {
          headers: {
            Authorization: "Token 6b4784095912d84d183b321f3fcc0713ce47e150",
          },
        }
      );
    },
    getDeliveryPointsMapsZoom(payload) {
      return instance.get("api/v1/deliveryPointsMapsZoom/", {
        params: payload,
      });
    },
    getInfoDeliveryPoint(point_id) {
      return instance.get("api/v1/pointOfIssue/" + point_id + "/");
    },
    getAddressCoords(lon, lat) {
      return instance.get("api/v1/addressCoords/?lon=" + lon + "&lat=" + lat);
    },
    getCheckOzon() {
      return instance.get("api/v1/checkOzon");
    },
    getDeliveryInfoFromCity(payload) {
      return instance.get("api/v1/deliveryInfoFromCity/", {
        params: payload,
      });
    },
    checkDaysCourier(lat, lon, address) {
      return instance.get(
        "api/v1/checkDaysCourier/?lat=" +
          lat +
          "&lon=" +
          lon +
          "&address=" +
          address
      );
    },
    checkExpressCourier(lat, lon, date) {
      return instance.get(
        "api/v1/checkExpressCourier/?lat=" +
          lat +
          "&lon=" +
          lon +
          "&date=" +
          date
      );
    },
    getProductFeedbackEval(product_id) {
      return instance.get(
        "api/v1/shopProductReviewsEval/?product_id=" + product_id
      );
    },
    getProductFeedback(product_id, count, page, payload) {
      return instance.get(
        "api/v1/shopProductReviews/?product_id=" +
          product_id +
          "&count=" +
          count +
          "&page_size=" +
          page,
        { params: payload }
      );
    },
    getProductQuestions(product_id) {
      return instance.get(
        "api/v1/shopProductQuestions/?product_id=" + product_id
      );
    },
    getIsOrdersOnProduct(product_id) {
      return instance.get(
        "api/v1/shopIsOrdersOnProduct/?product_id=" + product_id
      );
    },
    postAddFeedback(payload) {
      return instance.post("api/v1/shopProductAddReview/", payload);
    },
    postAddQuestion(payload) {
      return instance.post("api/v1/shopProductAddQuestion/", payload);
    },
    getCountProductsCatalog(payload) {
      return instance.get("api/v1/countProductsCatalog/1/", {
        params: payload,
      });
    },
    getParamsCatalog() {
      return instance.get("api/v1/paramsCatalog/1/");
    },
    getProductsCatalog(payload) {
      return instance.get("api/v1/productsCatalog/1/", {
        params: payload,
      });
    },
    getBlogCategories() {
      return instance.get("api/v1/shopBlogCategories/");
    },
    getBlogArticles(payload) {
      return instance.get("api/v1/shopBlogArticles/?site_id=1", {
        params: payload,
      });
    },
    getMainBlogArticles() {
      return instance.get("api/v1/shopMainBlogArticles/?site_id=1");
    },
    postBlogArticleCountViews(article_id) {
      return instance.put(
        "api/v1/shopBlogArticleCountViews/" + article_id + "/"
      );
    },
    postBlogArticleCountShare(article_id) {
      return instance.put(
        "api/v1/shopBlogArticleCountShare/" + article_id + "/"
      );
    },
    postBlogArticleCountRecommendation(article_id) {
      return instance.put(
        "api/v1/shopBlogArticleCountRecommendation/" + article_id + "/"
      );
    },
    postBlogArticleCountProduct(article_id) {
      return instance.put(
        "api/v1/shopBlogArticleCountProduct/" + article_id + "/"
      );
    },
    postProductCountViews(product_id) {
      return instance.put("api/v1/shopProductCountViews/" + product_id + "/");
    },
    getShopMainPage() {
      return instance.get("api/v1/shopMainPage/1/");
    },
    getShopMainPageBanner() {
      return instance.get("api/v1/shopMainPageBanner/1/");
    },
    getShopMainPageStory() {
      return instance.get("api/v1/shopMainPageStory/1/");
    },
    getShopMainPageSelection() {
      return instance.get("api/v1/shopMainPageSelection/1/");
    },
    getShopMainPageReview() {
      return instance.get("api/v1/shopMainPageReview/1/");
    },
    getShopProductUserPurchases(payload) {
      return instance.get("api/v1/shopProductUserPurchases/", {
        params: payload,
      });
    },
    getShopProductUserRecommendations(payload) {
      return instance.get("api/v1/shopProductUserRecommendations/", {
        params: payload,
      });
    },
    getShopProductUserFavorites(payload) {
      return instance.get("api/v1/shopProductUserFavorites/", {
        params: payload,
      });
    },
    getShopProductUserFavorite(product_id) {
      return instance.get(
        "api/v1/shopProductUserFavorite/?product_id=" + product_id
      );
    },
    getShopProductUserViews() {
      return instance.get("api/v1/shopProductUserViews/");
    },
    getShopProductUserQuestionnaire(payload) {
      return instance.get("api/v1/shopProductUserQuestionnaire/", {
        params: payload,
      });
    },
    postShopProductUserView(payload) {
      return instance.post("api/v1/shopProductUserView/", payload);
    },
    postShopProductUserAvailable(payload) {
      return instance.post("api/v1/shopProductUserAvailable/", payload);
    },
    getShopProductUserAvailable(product_id) {
      return instance.get(
        "api/v1/shopProductUserAvailable/?product_id=" + product_id
      );
    },
    postShopProductUserFavorite(payload) {
      return instance.post("api/v1/shopProductUserFavorite/", payload);
    },
    getShopProductUserBasket(product_id) {
      return instance.get(
        "api/v1/checkShopProductUserBasket/" + product_id + "/"
      );
    },
    postShopProductUserBasket(payload) {
      return instance.post("api/v1/shopProductUserBasket/", payload);
    },
    getShopProductsInfo(product_id) {
      return instance.get("api/v1/productsInfo/?product_id=" + product_id);
    },
    getShopProductUserBasketCount() {
      return instance.get("api/v1/shopProductUserBasketCount/");
    },
    getShopProductUserBaskets() {
      return instance.get("api/v1/shopProductUserBasket/?count=10000");
    },
    postShopCreateOrder(payload) {
      return instance.post("api/v1/shopCreateOrder/", payload);
    },
    postQuestionnaireCreateOrder(payload) {
      return instance.post("api/v1/questionnaireCreateOrder/", payload);
    },
    postShopCreateReturn(payload) {
      return instance.post("api/v1/shopCreateReturn/", payload);
    },
    postShopUpdateReturn(payload) {
      return instance.post("api/v1/shopUpdateReturn/", payload);
    },
    postShopConfirmReturn(payload) {
      return instance.post("api/v1/shopConfirmReturn/", payload);
    },
    postShopGeneratorPaymentOrder(order_id) {
      return instance.post(
        "api/v1/shopGeneratorPaymentOrder/" + order_id + "/"
      );
    },
    postShopCancelOrder(order_id) {
      return instance.post("api/v1/shopCancelOrder/" + order_id + "/");
    },
    postShopAddPaymentCard(payload) {
      return instance.post("api/v1/shopAddPaymentCard/", payload);
    },
    getPromoCodeValueCheck(value) {
      return instance.get("api/v1/promoCode/" + value + "/?check=1");
    },
    getPromoCodeValue(value) {
      return instance.get("api/v1/promoCode/" + value + "/");
    },
    checkPromoCode(promo_code) {
      return instance.get("api/v1/checkPromoCode/?promo_code=" + promo_code);
    },
    checkIdGiftCard(gift_card_id) {
      return instance.get("api/v1/checkIdGiftCard/?id=" + gift_card_id);
    },
    promoCodeForPartner(partner_code) {
      return instance.get(
        "api/v1/checkPromoCode/?partner_code=" + partner_code
      );
    },
    checkPromoCodeProduct(promo_code, product_id) {
      return instance.get(
        "api/v1/checkPromoCodeProduct/?promo_code=" +
          promo_code +
          "&product_id=" +
          product_id
      );
    },
    putShopArticleUserLike(article_id) {
      return instance.put("api/v1/shopArticleUserLike/" + article_id + "/");
    },
    putShopProductReviewUserLike(review_id) {
      return instance.put(
        "api/v1/shopProductReviewUserLike/" + review_id + "/"
      );
    },
    postShopTrackerClick(payload) {
      return instance.post("api/v1/shopTrackerClick/", payload);
    },
    postShopAutoTracker(payload) {
      return instance.post("api/v1/shopAutoTracker/", payload);
    },
    postShopTrackerClickBasket(payload) {
      return instance.post("api/v1/shopTrackerClickBasket/", payload);
    },
    postShopSearchSession(payload) {
      return instance.post("api/v1/shopSearchSession/", payload);
    },
    postShopSearchSessionProducts(payload) {
      return instance.post("api/v1/shopSearchSessionProducts/", payload);
    },
    postShopSearchSessionClickProduct(payload) {
      return instance.post("api/v1/shopSearchSessionClickProduct/", payload);
    },
    postShopSearchSessionBasket(payload) {
      return instance.post("api/v1/shopSearchSessionBasket/", payload);
    },
    getShopSearchPopularQueries(value) {
      return instance.get(
        "api/v1/shopSearchPopularQueries/?user_hash=" + value
      );
    },
    getShopSearchPopularProducts(value) {
      return instance.get("api/v1/shopSearchPopularProducts/?count=" + value);
    },
    deleteShopSearchStoryQuery(payload) {
      return instance.post("api/v1/shopSearchStoryQuery/", payload);
    },
    getShopSearchQueryProducts(value) {
      return instance.get("api/v1/shopSearchQueryProducts/?value=" + value);
    },
    getShopSearchPromptQuery(value, config = {}) {
      return instance.get(
        "api/v1/shopSearchPromptQuery/?value=" + value,
        config
      );
    },
    getShopSearchPromptProduct(value, config = {}) {
      return instance.get(
        "api/v1/shopSearchPromptProduct/?value=" + value,
        config
      );
    },
    postShopProductStatistics(payload) {
      return instance.post("api/v1/shopProductStatistics/", payload);
    },
    getPromotionFromPath(slug) {
      return instance.get("api/v1/promotionFromPath/?value=" + slug);
    },
    getPromotionActive() {
      return instance.get("api/v1/promotionActive/");
    },
    getQuestionnaireFromPath(slug) {
      return instance.get("api/v1/questionnaireFromPath/?value=" + slug);
    },
    getPromotionProducts(payload) {
      return instance.get("api/v1/promotionProducts/", {
        params: payload,
      });
    },
    getProductGiftCardsNominals() {
      return instance.get("api/v1/productGiftCardsNominals");
    },
    getGiftCardFromPath(slug) {
      return instance.get("api/v1/giftCardFromPath/?value=" + slug);
    },
    getGiftCardView(payload) {
      return instance.post("api/v1/giftCardView/", payload);
    },
    getQuestionnaires(payload) {
      return instance.get("api/v1/questionnaires/", {
        params: payload,
      });
    },
    getShopAllProducts() {
      return instance.get("api/v1/shopAllProducts/");
    },
    postMedicineChest(payload) {
      return instance.post("api/v1/medicineChestDetail/", payload);
    },
    putMedicineChest(id, payload) {
      return instance.put("api/v1/medicineChestDetail/" + id + "/", payload);
    },
    deleteMedicineChest(id) {
      return instance.delete("api/v1/medicineChestDetail/" + id + "/");
    },
    getMedicineChests(payload) {
      return instance.get("api/v1/medicineChests/", {
        params: payload,
      });
    },
    postMedicineChestPeriod(payload) {
      return instance.post("api/v1/medicineChestPeriodDetail/", payload);
    },
    putMedicineChestPeriod(id, payload) {
      return instance.put(
        "api/v1/medicineChestPeriodDetail/" + id + "/",
        payload
      );
    },
    deleteMedicineChestPeriod(id) {
      return instance.delete("api/v1/medicineChestPeriodDetail/" + id + "/");
    },
    putMedicineChestReceptionAcceptance(id) {
      return instance.put(
        "api/v1/medicineChestReceptionAcceptance/" + id + "/"
      );
    },
    getMedicineChestPeriods(id) {
      return instance.get(
        "api/v1/medicineChestPeriods/?medicine_chest_id=" + id
      );
    },
    putMedicineChestStatus(id, payload) {
      return instance.put("api/v1/medicineChestStatus/" + id + "/", payload);
    },
    postViewStatistics(payload) {
      return instance.post("api/v1/viewStatistics/", payload);
    },
    postPromotionStatistics(payload) {
      return instance.post("api/v1/setPromotionStatistics/", payload);
    },
    getShopPagesList() {
      return instance.get("api/v1/shopPagesList/");
    },
    getChatMessages(order_id) {
      return instance.get("api/v1/chatMessages/" + order_id + "/");
    },
    postSendEvalOrder(payload) {
      return instance.post("api/v1/sendEvalOrder/", payload);
    },
    postSendFeedbackTextOrder(payload) {
      return instance.post("api/v1/sendFeedbackTextOrder/", payload);
    },
    postSendChatMessage(payload) {
      return instance.post("api/v1/sendChatMessage/", payload);
    },
    postOrderToMc(payload) {
      return instance.post("api/v1/orderToMedicineChest/", payload);
    },
    postChangeChatMessageRead(payload) {
      return instance.post("api/v1/changeChatMessageRead/", payload);
    },
  };
}
